export const ELVES_SIZE_FOR_SUPPLY = 1;
export const ELVES_SIZE_FOR_SUPPLY_WITH_MILITARY_CAMP = 2;
export const ELVES_SHOOTING_RANGE = 4;